import { type RoutePackage } from './RoutePackage';
import { RoutePackageLoader } from './RoutePackageLoader';
import { type RoutePackageLoaderConfig } from './types';
import ItineraryPackageSet from '@itinerary/ItineraryPackageSet';

export default class RoutePackageSet extends ItineraryPackageSet<
    {},
    '',
    RoutePackage
> {
    override sortBy: any;
    override loader: RoutePackageLoader;

    public override reset(config: RoutePackageLoaderConfig) {
        super.reset(config, { '': '' });
        this.loader = new RoutePackageLoader(config);
    }

    get adultCount() {
        return this.loader.adultCount;
    }

    get childCount() {
        return this.loader.childCount;
    }

    get infantCount() {
        return this.loader.infantCount;
    }

    constructor(config: RoutePackageLoaderConfig) {
        super({ '': '' });
        this.loader = new RoutePackageLoader(config);
    }
}
